import React from 'react';
import SashiDo from 'lib/SashiDo';

import stylesButton from 'components/Button/Button.scss';
import Notification from 'components/Notification/Notification.react';
import Field from 'components/Field/Field.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import InlineSubmitInput from 'components/InlineSubmitInput/InlineSubmitInput.react';
import Label from 'components/Label/Label.react';
import styles from 'dashboard/Settings/Settings.scss';
import PropTypes from 'prop-types';
import validateEmailFormat from 'lib/validateEmailFormat';
import Gravatar from 'react-gravatar';


// Component for displaying and modifying an app's collaborator emails.
// There is a single input field for new collaborator emails. As soon as the
// user types a valid email format (and not already existing collaborator), we
// will show an ADD button. When the user clicks the ADD button, we make a call
// to the server to check that the email is a valid Parse account. If so, then
// we'll invoke the onAdd handler of this component. Please note that this
// component does NOT actually add the collaborator to your app on the server;
// the parent component is responsible for doing that when onAdd is invoked.
// The parent also is responsible for passing onRemove, which is called when the
// users removes a collaborator.
export default class Collaborators extends React.Component {
  constructor(props) {
    super();

    this.state = { lastError: '' };
  }

  handleAdd(newEmail) {
    this.props.collaborators.forEach((item) => {
      if (item.username.toLowerCase() === newEmail.toLowerCase()) {
        this.setState({ lastError: { type: 'error', message: `${newEmail} is already a collaborator to this app.` } });
        return null;
      }
    });

    return SashiDo.validateCollaborator(newEmail.toLowerCase())
      .then(({ response, error }) => {
        if (error) {
          if (error.response.data.code === 205) {
            this.setState({ lastError: { type: 'error', message: `There is no SashiDo account with email: ${newEmail}.` } });
          }

          if (error.response.data.code === 206) {
            this.setState({ lastError: { type: 'error', message: `SashiDo account with email: ${newEmail} is not activated` } });
          }
        }

        if (response) {
          const newCollaborators = this.props.collaborators.concat({ username: newEmail.toLowerCase() });
          this.setState({ lastError: '' });
          this.props.onAdd(newEmail.toLowerCase(), newCollaborators);
        }
      });
  }

  handleDelete(collaborator) {
    const newCollaborators = this.props.collaborators.filter(oldCollaborator => oldCollaborator.username.toLowerCase() !== collaborator.username.toLowerCase());
    this.props.onRemove(collaborator, newCollaborators);
  }

  onChange = (value) => {
    const collaborators = this.props.collaborators.map((user) => {
      return user.username;
    });

    let lastError = null;
    if (collaborators.includes(value)) {
      lastError = { type: 'error', message: `${value} is already collaborator to this app.` };
    }

    this.setState({ lastError });
  }

  validateEmail(email) {
    // We allow mixed-case emails for Parse accounts
    const isExistingCollaborator = !!this.props.collaborators.find((collab) => {
      email.toLowerCase() === collab.username;
    });

    return validateEmailFormat(email.toLowerCase()) &&
      !isExistingCollaborator &&
      this.props.ownerEmail.toLowerCase() !== email.toLowerCase();
  }

  render() {
    const collaborators = this.props.collaborators.filter(i => !i.is_owner);

    return (
      <BoxFieldset el="settings__general_collaborators">
        <div className={styles.settingsBox}>
          <Notification note={this.state.lastError} close />
          <Notification note={this.state.newCollaborator} close />
          {
            this.props.viewerEmail === this.props.ownerEmail
              ?
                <Field
                  label={<Label
                    text="Add new collaborator" />
                  }
                  input={<InlineSubmitInput
                    validate={email => this.validateEmail(email)}
                    placeholder="What&#39;s their email?"
                    onChange={this.onChange}
                    onSubmit={this.handleAdd.bind(this)}
                    submitButtonText="ADD" />
                } />
              : null
          }

          {
            collaborators.length
              ?
                <Field
                  label={<Label
                    text="Existing collaborators" />
                  }
                  input={
                    <ul className={styles.container}>
                      {
                        collaborators.map((collaborator) => {
                          const collaboratorUsername = collaborator.username;

                          const canDelete = this.props.viewerEmail === this.props.ownerEmail || collaboratorUsername === this.props.viewerEmail;
                          // TODO(drewgross): add a warning modal for when you are removing yourself as a collaborator, as that is irreversable

                          const row = (
                            <li key={collaborator.objectId}>
                              <div className={styles.avatar}>
                                <Gravatar email={collaboratorUsername} size={30} default="mm" />
                              </div>
                              {
                                // @TODO: [GDPR] - we should get user name from chargebee and return it with the user object
                                (collaborator.first_name && collaborator.last_name)
                                  ? <div className={styles.name}>{collaborator.first_name} {collaborator.last_name}</div>
                                  : <div className={styles.name}><span>no name</span></div>
                              }
                              <span className={styles.email}>{collaboratorUsername}</span>
                              {
                                collaboratorUsername === this.props.ownerEmail
                                  ? 'App Owner'
                                  :
                                  <a
                                    className={[stylesButton.tableButton, stylesButton.red].join(' ')}
                                    href="javascript:;"
                                    onClick={canDelete ? this.handleDelete.bind(this, collaborator) : undefined}>
                                      Delete
                                  </a>
                              }
                            </li>
                          );
                          return row;
                        })
                      }
                    </ul>
                  } />
             : null}
        </div>
      </BoxFieldset>
    );
  }
}

Collaborators.propTypes = {
  collaborators: PropTypes.arrayOf(PropTypes.any).isRequired,
  ownerEmail: PropTypes.string,
  viewerEmail: PropTypes.string,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
